import { HeadDotsHorizontalOutlineIcon } from './HeadDotsHorizontalOutlineIcon';

/**
 * author: Michael Irigoyen
 * id E07B33BA-5E14-45A2-AE38-EA80CE0ED909
 * name head-dots-horizontal-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-dots-horizontal-outline.svg
 * tags
 */
export const HeadThinkingOutlineIcon = HeadDotsHorizontalOutlineIcon;
export default HeadThinkingOutlineIcon